var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgToolsForHumanityLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100.000000pt",
    height: "100.000000pt",
    viewBox: "0 0 100.000000 100.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,100.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 710 l0 -100 140 0 140 0 0 -225 0 -225 106 0 105 0 -3 248 c-3 234 -4 249 -25 289 -25 47 -71 84 -122 102 -20 6 -99 11 -187 11 l-154 0 0 -100z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M646 795 c-49 -17 -93 -59 -117 -110 -16 -35 -19 -68 -19 -282 l0 -243 100 0 100 0 2 222 3 223 143 3 142 3 0 99 0 100 -157 0 c-108 -1 -170 -5 -197 -15z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToolsForHumanityLogo);
export default __webpack_public_path__ + "static/media/Tools_for_Humanity_logo.7d05113cb572fa7260eb13c94c11e3ce.svg";
export { ForwardRef as ReactComponent };